// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","label":"OlOjtKBV9fmf","container":"_2mLtWgNvBig8"};